// frontend/src/pages/EditJuvenilePage.js (Corrected)
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../api';
import JuvenileForm from '../components/JuvenileForm';

function EditJuvenilePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [juvenileData, setJuvenileData] = useState(null);
  const [error, setError] = useState('');

  const fetchJuvenile = useCallback(async () => {
    try {
      const response = await apiClient.get(`/api/juveniles/${id}`);
      // The backend sends the juvenile object directly
      setJuvenileData(response.data);
    } catch (err) {
      console.error("Failed to fetch juvenile data for editing", err);
      setError('Failed to load juvenile data for editing.');
    }
  }, [id]);

  useEffect(() => {
    fetchJuvenile();
  }, [fetchJuvenile]);

  const handleUpdate = async (formData) => {
    try {
      await apiClient.put(`/api/juveniles/${id}`, formData);
      navigate(`/juveniles/${id}`);
    } catch (err) {
      console.error("Failed to update juvenile", err);
      setError('Failed to save changes.');
    }
  };

  if (error) {
    return <div className="card"><p className="text-red-500">{error}</p></div>;
  }
  
  if (!juvenileData) {
    return <div className="card"><p>Loading for edit...</p></div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-800 mb-4">
        Edit Profile: {juvenileData.first_name} {juvenileData.last_name}
      </h1>
      <JuvenileForm onSubmit={handleUpdate} initialData={juvenileData} />
    </div>
  );
}

export default EditJuvenilePage;